import React from 'react';
import Navscont from '../sections/sec-navs';



const Contentmangemntnav = () => {
    return ( 
        <>
                <section className='home'>
                <div className='circle-dec-sec1'></div>
                <div className='circl2-sec1-dec'></div>
              <Navscont />
                </section>
        </>
     );
}
 
export default Contentmangemntnav;